module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('f7-page', {
    attrs: {
      "name": "deleted"
    }
  }, [_c('f7-navbar', {
    staticClass: "navbar-container"
  }, [_c('f7-nav-center', {
    staticClass: "navbar-center"
  }, [_c('div', {
    staticClass: "logo_text"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.logo
    }
  })])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/icons/custom/sad-smile.svg",
      "alt": "sad smile"
    }
  }), _vm._v(" "), _c('h1', [_vm._v("We’re sorry")]), _vm._v(" "), _vm._t("default")], 2)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a51e3178", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a51e3178"}!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/src/pages/deleted/deleted-common.vue
// module id = 808
// module chunks = 0